/*
 * @Author: niuqingxia
 * @Date: 2024-12-19 18:17:56
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2024-12-Mo 03:50:56
 纯数字
 */

<template>
  <div :key="uniqueKey" class="number-chart">
    <div
      ref="numberContainer"
      class="number-container">
      <div class="number-content">
        <div
          class="number-chart-title"
          :style="{
            textAlign: config.chartSet.titleStyle.align,
            fontSize: config.chartSet.titleStyle.fontSize + 'px',
            color: config.chartSet.titleStyle.color,
          }">
          {{ config.chartTitle }}
          <el-tooltip v-if="config.chartViewData.showIndicator" class="item" :open-delay="500" effect="dark" placement="top">
            <div slot="content" v-html="indicatorDescription"></div>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </div>
        <div class="number-text-wrap">
          <span
            v-if="config.chartSet.chartStyle.hasSymbol && config.chartSet.chartStyle.symbolPosition === 'left'"
            :style="{
              color: config.chartSet.chartStyle.symbolColor,
              fontSize: config.chartSet.chartStyle.symbolFontSize + 'px',
            }">{{ config.chartSet.chartStyle.symbolText }}</span>
          <span
            class="number-text"
            :style="{
              fontSize: config.chartSet.chartStyle.fontSize + 'px',
              color: config.chartSet.chartStyle.color,
              lineHeight: '100%',
            }">
            {{ curNumber }}
          </span>
          <span
            v-if="config.chartSet.chartStyle.hasSymbol && config.chartSet.chartStyle.symbolPosition === 'right'"
            :style="{
              color: config.chartSet.chartStyle.symbolColor,
              fontSize: config.chartSet.chartStyle.symbolFontSize + 'px',
            }">{{ config.chartSet.chartStyle.symbolText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { COLOR_LIST } from '@/utils/defaultColorData'
import ChartMixin from '../mixin'
export default {
  name: 'NumberChart',
  mixins: [ChartMixin],
  props: {
    config: {
      type: Object,
    },
    componentType: {
      type: String,
    },
    globalConfig: {
      type: Object,
    },

  },
  data () {
    return {
      uniqueKey: 'xxx',

    }
  },
  computed: {
    // 表格数据
    chartData () {
      return this.config.chartViewData.chartData
    },
    curNumber () {
      if (!this.chartData?.length) return
      // 除第一列(维度)之外的所有表头key集合 keyList
      const colKeyList = Object.keys(this.chartData[0])
      // 表格数据 (去除第一行(表头))
      const tableData = this.chartData.slice(1)
      return tableData[0][colKeyList[0]] // 第一个单元格数据
    },
  },
  watch: {
    // 全局样式监听
    'globalConfig.chartColors': {
      handler () {
        // 主题颜色修改
        this.config.chartSet.borderStyle.color = COLOR_LIST.filter(item => { return item.label === this.globalConfig.chartColors })[0].value[0]
      },
      deep: true,
    },
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.uniqueKey = Math.random()
    },

    // 千分位
    getNumberFormat (val) {
      return (val + '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

  },
}
</script>

<style lang="scss" scoped>
.number-chart{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  &-title {
    padding: 0 10px;
    margin-top: 5px;
    margin-bottom: 10px;
  }
  .number-container{
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    .number-content{
      width: 100%;
    }
    .number-text-wrap{
      display: flex;
      align-items: flex-end;
      justify-content: center;
      font-family: BigruixianBlackGBV;
      .number-text{
        text-align: center;
        cursor: default;
      }
    }
    .number-bg{
      position: absolute;
      &.number-bg1{
        left: 0;
        top: 0;
      }
      &.number-bg2{
        right: 0;
        top: 0;
      }
      &.number-bg3{
        bottom: 0;
        right: 0;
      }
      &.number-bg4{
        left: 0;
        bottom: 0;
      }
      &.number-bg5{
        top: 0;
      }
      &.number-bg6{
        bottom: 0;
      }
      .a {
        // opacity: 0.15;
        fill: #0276fa;
      }
    }
  }
}
</style>
